import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { CircularProgress, Box } from '@mui/material';
import AuthRequiredGate from './AuthRequiredGate';

/**
 * Once auth resolves, redirect guests immediately (preserve return URL).
 * AUTH-49: also put returnTo in the query string so hard navigations / copy-paste
 * still restore the destination after login (location.state alone is not visible).
 */
const PrivateRoute = ({ children, inlineGate = false }) => {
  const { currentUser, isLoading } = useAuth();
  const location = useLocation();

  if (currentUser) {
    return children;
  }

  if (isLoading) {
    if (inlineGate) {
      return <AuthRequiredGate loading />;
    }
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="50vh"
      >
        <CircularProgress />
      </Box>
    );
  }

  if (inlineGate) {
    return <AuthRequiredGate />;
  }

  const from = `${location.pathname}${location.search}${location.hash}`;
  const qs = new URLSearchParams();
  if (from && from !== '/login' && from !== '/register') {
    qs.set('returnTo', from);
  }
  const search = qs.toString();

  return (
    <Navigate
      to={search ? `/login?${search}` : '/login'}
      replace
      state={{ from }}
    />
  );
};

export default PrivateRoute;
